import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import API from "./config/API";

function ConfigurationSetupCount() {
  const [data, setData] = useState(null);
  const [message, setMessage] = useState("");
  const [messageColor, setMessageColor] = useState("green");

  const navigate = useNavigate();

  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const emailId = loggedUser?.emailId || "";

  const [bedSearch, setBedSearch] = useState("");
  const rooms = data?.["Total Rooms Count "] || [];
  const beds = data?.["Total Beds Count "] || [];

  const [selectedFloor, setSelectedFloor] = useState("");

  const roleType = localStorage.getItem("roleType") || "";
  //const canNavigate = roleType === "APP_ADMIN" || roleType === "APP_EXECUTOR";
  const allowedRoles = ["APP_ADMIN", "APP_EXECUTOR"];

  const canNavigate = allowedRoles.includes(roleType.trim().toUpperCase());

  const floorColors = [
    "#dbeafe", // Blue
    "#dcfce7", // Green
    "#fef3c7", // Yellow
    "#fce7f3", // Pink
    "#ede9fe", // Purple
    "#cffafe", // Cyan
  ];

  const getFloorColor = (floorName) => {
    const uniqueFloors = [...new Set(rooms.map((item) => item.FloorName))];

    const floorIndex = uniqueFloors.indexOf(floorName);

    return floorColors[floorIndex >= 0 ? floorIndex % floorColors.length : 0];
  };

  useEffect(() => {
    if (emailId) fetchData();
  }, [emailId]);

  const filteredBeds = beds.filter((item) =>
    item.roomName?.toLowerCase().includes(bedSearch.toLowerCase()),
  );

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${API.V1}/maxLimit/getConfigurationFloorsRoomsBedsCount`,
        {
          params: {
            emailId: emailId,
          },
          headers: {
            Authorization: `Bearer ${loggedUser?.jwtToken}`,
            "Content-Type": "application/json",
          },
        },
      );

      const response = res.data;

      if (response.statusCode === 200) {
        setData(response.data);
        setMessage(response.message);
        setMessageColor("green");
      } else if (response.statusCode === 400) {
        setMessage(response.message);
        setMessageColor("orange");
      } else {
        setMessage(response.message || "Something went wrong");
        setMessageColor("red");
      }
    } catch (err) {
      setMessage("Server down, please try after sometime !");
      setMessageColor("red");
    }
  };

  return (
    <div style={styles.container}>
      {/* SIDEBAR */}
      <div style={styles.sidebar}>
        <h2 style={styles.logo}>PG SYSTEM</h2>

        <Link to="/dashboard" style={styles.link}>
          🏠 Dashboard
        </Link>
        <Link
          to={canNavigate ? "/maxFloorCountForm" : "#"}
          state={{
            maxFloorCount: data?.["Total floors Count"] ?? 0,
          }}
          style={{
            ...styles.link,
            cursor: canNavigate ? "pointer" : "not-allowed",
            opacity: canNavigate ? 1 : 0.5,
          }}
          onClick={(e) => {
            if (!canNavigate) {
              e.preventDefault();
              return;
            }
          }}
        >
          👥 Floors {!canNavigate && "🔒"}
        </Link>
        <Link to="/roomMaxSetUp" style={styles.link}>
          🏢 Rooms
        </Link>
        <Link to="/bedMaxCountForm" style={styles.link}>
          🛏 Beds
        </Link>
      </div>

      {/* MAIN */}
      <div style={styles.main}>
        <h2 style={styles.heading}>Configuration Setup Max Count</h2>

        {/* MESSAGE ALWAYS SHOW */}
        {message && (
          <div
            style={{
              ...styles.messageBox,
              background:
                messageColor === "green"
                  ? "#dcfce7"
                  : messageColor === "orange"
                    ? "#fef3c7"
                    : "#fee2e2",
              color:
                messageColor === "green"
                  ? "#166534"
                  : messageColor === "orange"
                    ? "#92400e"
                    : "#991b1b",
            }}
          >
            {message}
          </div>
        )}

        {/* EMPTY STATE HANDLING */}
        {!data ? (
          <div style={styles.emptyBox}>
            <b>No Data</b>
          </div>
        ) : (
          <div style={styles.grid}>
            {/* FLOORS */}
            <div
              style={{
                ...styles.card,
                cursor: canNavigate ? "pointer" : "default",
                opacity: canNavigate ? 1 : 0.8,
              }}
              onClick={() => {
                if (!canNavigate) return;

                navigate("/maxFloorCountForm", {
                  state: {
                    floorCount: data?.["Total floors Count"] || 0,
                  },
                });
              }}
            >
              {" "}
              <h3 style={styles.cardTitle}>
                🏢 Floors Summary {!canNavigate && "🔒"}
              </h3>{" "}
              <div style={styles.countBox}>
                <span>Total Floors</span>
                <b>{data["Total floors Count"]}</b>
              </div>
            </div>

            {/* ROOMS */}
            <div
              style={{
                ...styles.card,
                cursor: canNavigate ? "pointer" : "default",
              }}
              onClick={() => {
                if (canNavigate) {
                  navigate("/roomMaxSetUp");
                }
              }}
            >
              {" "}
              <h3 style={styles.cardTitle}>
                🏠 Rooms Count {!canNavigate && "🔒"}
              </h3>{" "}
              <div style={styles.tableHeader}>
                <span>Floor Name</span>
                <span>Rooms</span>
              </div>
              <div style={styles.scroll}>
                {rooms.map((item, i) => (
                  <div key={i} style={styles.row}>
                    <span style={styles.blueText}>{item.FloorName}</span>
                    <span style={styles.greenText}>{item.roomsCount}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* BEDS */}
            {/* BEDS */}
            <div
              style={{
                ...styles.card,
                cursor: canNavigate ? "pointer" : "default",
              }}
              onClick={() => {
                if (canNavigate) {
                  navigate("/bedMaxCountForm");
                }
              }}
            >
              {" "}
              <h3 style={styles.cardTitle}>
                🛏 Beds Count {!canNavigate && "🔒"}
              </h3>{" "}
              {/* SEARCH */}
              <input
                type="text"
                placeholder="Search Room Name..."
                value={bedSearch}
                onChange={(e) => setBedSearch(e.target.value)}
                style={styles.searchInput}
              />
              <div style={styles.tableHeader}>
                <span>Room Name</span>
                <span>Beds</span>
              </div>
              <div style={styles.scroll}>
                {filteredBeds.length > 0 ? (
                  filteredBeds.map((item, i) => (
                    <div
                      key={i}
                      style={{
                        ...styles.row,
                        background: getFloorColor(item.floorName),
                      }}
                    >
                      <span style={styles.purpleText}>
                        {item.floorName}-{item.roomName}
                      </span>

                      <span style={styles.redText}>{item.maxbedsCount}</span>
                    </div>
                  ))
                ) : (
                  <p style={styles.noData}>No Room Found</p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ConfigurationSetupCount;

/* ================= STYLES ================= */

const styles = {
  container: {
    display: "flex",
    height: "100vh",
    background: "#f1f5f9",
  },

  searchInput: {
    width: "100%",
    padding: "10px",
    marginBottom: "12px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    outline: "none",
    fontSize: "14px",
    boxSizing: "border-box",
  },

  card: {
    background: "#fff",
    padding: "15px",
    borderRadius: "12px",
    transition: "0.3s ease",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },

  noData: {
    textAlign: "center",
    color: "red",
    fontWeight: "bold",
  },

  sidebar: {
    width: "260px",
    background: "#0f172a",
    color: "#fff",
    padding: "20px",
  },

  logo: {
    textAlign: "center",
    color: "#38bdf8",
    marginBottom: "25px",
  },

  link: {
    display: "block",
    padding: "12px",
    marginBottom: "10px",
    color: "#fff",
    textDecoration: "none",
    background: "#1e293b",
    borderRadius: "6px",
  },

  main: {
    flex: 1,
    padding: "20px",
  },

  heading: {
    textAlign: "center",
    marginBottom: "15px",
  },

  messageBox: {
    padding: "10px",
    borderRadius: "8px",
    marginBottom: "15px",
    textAlign: "center",
    fontWeight: "bold",
  },

  emptyBox: {
    textAlign: "center",
    marginTop: "50px",
    color: "#64748b",
    fontSize: "18px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "20px",
    alignItems: "start",
  },

  card: {
    background: "#fff",
    padding: "15px",
    borderRadius: "12px",
  },

  cardTitle: {
    textAlign: "center",
    marginBottom: "10px",
  },

  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "bold",
    padding: "8px",
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    marginBottom: "8px",
    background: "#f8fafc",
    borderRadius: "6px",
  },

  scroll: {
    maxHeight: "350px",
    overflowY: "auto",
    paddingRight: "8px",
  },

  countBox: {
    display: "flex",
    justifyContent: "space-between",
    padding: "15px",
    background: "#e0f2fe",
    borderRadius: "8px",
    fontWeight: "bold",
  },

  blueText: { color: "#2563eb" },
  greenText: { color: "#16a34a" },
  purpleText: { color: "#7c3aed" },
  redText: { color: "#dc2626" },
};
